<div class="row">
  <div class="col">
    <div class="d-flex justify-content-between align-items-center mt-5">
      <!-- Left Section: Title + 2 Buttons -->
      <div class="d-flex align-items-center ">
        <!-- Button Group -->
        <div class="d-flex gap-2 align-items-center">
          <app-title [title]="messageDetailHeading"></app-title>

          <c11n-button class="d-none d-sm-block" [variant]="'primary'"
                       [labelText]="'Search'"
                       [iconName]="'search'"
                       [iconPosition]="'leading'"
                       [size]="'small'"
                       [colorMode]="'on-light'"
                       (clickEvent)="onMessageSearch()"
          ></c11n-button>
          <c11n-button class="d-none d-sm-block" [variant]="'secondary'"
                       [labelText]="'Show all'"
                       [size]="'small'"
                       [colorMode]="'on-light'"
                       (clickEvent)="onMessageShowAll()"
          ></c11n-button>
          <c11n-button *ngIf="hasMessageData || selectedMessageDetail" class="delete-button-blue d-none d-sm-block"
                       [variant]="'ghost'"
                       [labelText]="'Clear'"
                       [size]="'small'"
                       [colorMode]="'on-light'"
                       (clickEvent)="onMessageClear()"
          ></c11n-button>
        </div>
      </div>

      <!-- Right Section: Single Button - Vertically centered -->
      <div class="d-flex gap-2 align-items-center">
        <ng-container *appHasPermission="'create'">
          <c11n-button class="d-none d-sm-block" [variant]="'secondary'" *ngIf="!selectedMessageDetail"
                       [labelText]="'Add message'"
                       [size]="'small'"
                       [colorMode]="'on-light'"
                       (clickEvent)="onAddMessage()"
          ></c11n-button>
        </ng-container>
        <ng-container *ngIf="selectedMessageDetail">
          <c11n-button [variant]="'secondary'" class="d-none d-lg-block"
                       [labelText]="'View message'"
                       [size]="'small'"
                       [colorMode]="'on-light'"
                       (clickEvent)="onViewMessage()"
          ></c11n-button>
          <ng-container *appHasPermission="'create'">
            <c11n-button [variant]="'secondary'" class="d-none d-lg-block"
                         [labelText]="'Add message'"
                         [size]="'small'"
                         [colorMode]="'on-light'"
                         (clickEvent)="onAddMessage()"
            ></c11n-button>
          </ng-container>
        </ng-container>
        <!--  Use child component for nav-overflow menu -->
        <app-message-run-detail-navigation-overflow-menu [selectedMessageDetails]="selectedMessageDetail"
                                                         (menuItemClicked)="onMenuItemClick($event)">
        </app-message-run-detail-navigation-overflow-menu>

      </div>
    </div>
  </div>
</div>
<app-message-detail-search-modal
  (formSubmitClicked)="handleMessageFormSubmit($event)"></app-message-detail-search-modal>
